// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","new":"new_PerYv","overlayImage":"overlayImage_Cy6hN","overlayContainer":"overlayContainer_R1wC0"};